@if (!noFormTag) {
  <form class="bootstrap-validation-background--hidden" [formGroup]="form" (ngSubmit)="submit()">
    <portal-modal-header (onClose)="dismiss()"></portal-modal-header>
    <portal-modal-body>
      <portal-error-alert [error]="error"></portal-error-alert>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group mb-0">
              <label class="form-label" for="screenNumber">{{
                (allowAddingInternalNumber ? 'phoneNumbers.newNumber' : 'phoneNumbers.externalNumber')
                  | translate
              }}</label>
              <ng-select
                id="screenNumber"
                [clearable]="false"
                [highlightIfFormGroupIsInvalid]="true"
                [items]="items"
                [portalAutofocus]="true"
                [portalTippy]="'screenNumber.title' | translate"
                bindValue="value"
                formControlName="screenNumberId"
                portalInputValidityState
              >
                <ng-template let-item="item" ng-option-tmp>
                  <div class="d-flex justify-content-between">
                    <span>{{ item.label | translate }}</span>
                    @if (item.meta?.isOutgoing === true) {
                      <span class="badge text-bg-info">
                        {{ 'phoneNumber.direction.OUT' | portalTranslate }}
                      </span>
                    }
                  </div>
                  @if (item.meta?.description != null) {
                    <div class="mt-n1 me-1 text-muted text-truncate">
                      <small> {{ item.meta.description }}</small>
                    </div>
                  }
                </ng-template>
              </ng-select>
              <portal-form-validation-errors controlName="screenNumberId"></portal-form-validation-errors>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group mb-0">
              <label class="form-label" for="internal">{{ 'phoneNumber.internal' | translate }}</label>
              <input
                class="form-control"
                id="internal"
                [highlightIfFormGroupIsInvalid]="true"
                autocomplete="off"
                formControlName="internal"
                portalInputValidityState
                type="text"
              />
              <portal-form-validation-errors controlName="internal"></portal-form-validation-errors>
            </div>
          </div>
        </div>
      </div>
    </portal-modal-body>
    @if (warning != null) {
      <ngb-alert class="modal-footer__warning" [dismissible]="false" type="warning">
        {{ 'users.phoneNumbers.add.warning.' + warning | translate }}
      </ngb-alert>
    }
    <portal-modal-footer
      [form]="form"
      [pending]="pending"
      [saving]="saving"
      (onCancel)="dismiss()"
    ></portal-modal-footer>
  </form>
} @else {
  <div class="row" [formGroup]="form">
    <div class="col-12 col-sm-6">
      <div class="form-group mb-0">
        <label class="form-label" for="screenNumber">{{
          (allowAddingInternalNumber ? 'phoneNumbers.newNumber' : 'phoneNumbers.externalNumber') | translate
        }}</label>
        <ng-select
          id="screenNumber"
          [clearable]="false"
          [highlightIfFormGroupIsInvalid]="true"
          [items]="items"
          [portalAutofocus]="true"
          [portalTippy]="'screenNumber.title' | translate"
          bindValue="value"
          formControlName="screenNumberId"
          portalInputValidityState
        >
          <ng-template let-item="item" ng-option-tmp>
            <div class="d-flex align-items-center">
              <span>{{ item.label }}</span>
              @if (item.meta?.isOutgoing === true) {
                <span class="badge text-bg-info ms-1">
                  {{ 'phoneNumber.direction.OUT' | portalTranslate }}
                </span>
              }
            </div>
            @if (item.meta?.description != null) {
              <div class="mt-n1 me-1 text-muted text-truncate">
                <small> {{ item.meta.description }}</small>
              </div>
            }
          </ng-template>
        </ng-select>
        <portal-form-validation-errors controlName="screenNumberId"></portal-form-validation-errors>
      </div>
    </div>
    <div class="col-12 col-sm-6">
      <div class="form-group mb-0">
        <label class="form-label" for="internal">{{ 'phoneNumber.internal' | translate }}</label>
        <input
          class="form-control"
          id="internal"
          [highlightIfFormGroupIsInvalid]="true"
          autocomplete="off"
          formControlName="internal"
          portalInputValidityState
          type="text"
        />
        <portal-form-validation-errors controlName="internal"></portal-form-validation-errors>
      </div>
    </div>
    <div class="col-12">
      @if (availableOnlyAsOutgoingNumber) {
        <ngb-alert class="modal-footer__warning" [dismissible]="false" type="warning">
          {{ 'users.phoneNumbers.add.addOutgoingOnly' | translate }}
        </ngb-alert>
      }
    </div>
    <div class="col-12">
      @if (form.pending) {
        <div class="font-xs mt-1 text-info" type="info">
          <i class="far fa-circle-notch fa-spin me-1"></i>
          <span>{{ 'phoneNumbers.validatingExternalNumber' | translate }}</span>
        </div>
      }
      <portal-validation-errors class="invalid-feedback" [errors]="form.errors"></portal-validation-errors>
    </div>
  </div>
}
